(ns app.front.view.group.reporting.download-button
  (:require [app.front.entities :as entities]
            [app.front.ui.select :as ui-select]
            [app.reporting.model :as reporting-model]
            [core.front.carbon :as cc]
            [core.front.comm :as comm]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(defn- format-select [tr *format]
  [:div.w-96
   [ui-select/select {:id           "download-report-format-select"
                      :label-text   (tr [:reporting/select-download-file-format])
                      :values       reporting-model/file-formats
                      :class        "mb-4 w-full"
                      :allow-empty? false
                      :value        @*format
                      :on-change    #(reset! *format %)
                      :val->str     (fn [format]
                                      (tr [(keyword "file-format" format)]))}]])

(defn download-button [{:keys [base-url query tr disabled]}]
  (r/with-let [*format (r/atom :xlsx)]
    [:div
     [format-select tr *format]
     (cc/button
       {:href             (->> query
                               seq
                               (cons [:format @*format])
                               comm/encode-query-params
                               (str base-url))
        :icon             i/download
        :size             :field
        :class-name       "max-w-none"
        :icon-description ""
        :disabled         (boolean disabled)}
       (tr [:reporting/download-report] [(name @*format)]))]))

(defn- report-type->command [report-type]
  (if (reporting-model/is-admin-report? report-type)
    :report/generate-admin-report
    :report/generate-report))

(rf/reg-event-fx ::request-generate-report
  (fn [_ [_ {:keys [report-type group-id] :as parameters} format]]
    {:dispatch [:comm/command-monitored (let [admin-report? (reporting-model/is-admin-report? report-type)
                                              parameters    (cond-> parameters
                                                              (not admin-report?) (dissoc :group-id)
                                                              :always (dissoc :report-type))]
                                          {:command    (report-type->command report-type)
                                           :data       (cond-> (util/mmap parameters report-type format)
                                                         (not admin-report?) (assoc :group-id group-id))
                                           :on-success [::entities/apply-changes]})]}))

(rf/reg-sub ::report-generation-pending?
  (fn [[_ report-type]]
    [(rf/subscribe [:comm/command-processing? (report-type->command report-type)])
     (rf/subscribe [:app.front.view.group.reporting.list/reports report-type])])
  (fn [[cmd-processing? reports] _]
    (or cmd-processing?
        (->> reports
             (remove #(or (= :report.state/ready (:domain/state %))
                          ;; filter out possibly stale reports (over 3 minutes old)
                          (date-util/before?
                            (-> % :entity/created date-util/js-date->goog-date-time)
                            (-> (date-util/now) (date-util/goog-add-minutes -3)))))
             seq
             boolean))))

(defn generate-button [{:keys [query tr disabled]}]
  (r/with-let [*format (r/atom :xlsx)]
    [:div.mb-8
     [format-select tr *format]
     (cc/button
       {:on-click         #(>evt [::request-generate-report query @*format])
        :icon             i/download
        :disabled         (or (<sub [::report-generation-pending? (:report-type query)])
                              (boolean disabled))
        :size             :field
        :class-name       "max-w-none"
        :icon-description ""}
       (tr [:reporting/generate-report] [(name @*format)]))]))
